import React from 'react';

import { req } from 'react-reqq-lite';
import { useHistory } from 'react-router-dom';

import OnboardingAnimation from 'modules/common/components/OnboardingAnimation';

import * as c from '../contants';

function DeliveredOrder() {
  document.body.className = 'overflow-hidden';
  const history = useHistory();
  const [render, setRender] = React.useState(0);

  const dispatchRedirect = React.useCallback(() => {
    setTimeout(() => {
      req.set(c.GET_ORDER_DETAILS, {});
      history.push('/r/delivery');
    }, 3000);
  }, [history]);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setRender(1);
      dispatchRedirect();
    }, 3000);
    return () => {
      clearTimeout(timer);
    };
  }, [dispatchRedirect]);

  const dispatchRender = {
    0: (
      <div className="text-center space-y-1">
        <h4 className="font-bold text-xl lg:text-2xl px-10">Loading...</h4>
        <p className="text-sm font-medium text-gray-300 invisible">
          REDIRECTING...
        </p>
      </div>
    ),
    1: (
      <div className="text-center space-y-1">
        <h4 className="font-bold text-xl lg:text-2xl px-10 ">
          Done! Successfully Delivered
        </h4>
        <p className="text-sm font-medium text-gray-300">REDIRECTING</p>
      </div>
    ),
  };

  return (
    <div className="fixed w-screen h-screen inset-0">
      <div className="flex h-full w-full">
        <div className="m-auto flex flex-col">
          <div className="mx-auto">
            <OnboardingAnimation width="150px" />
          </div>
          {dispatchRender[render]}
        </div>
      </div>
    </div>
  );
}
DeliveredOrder.defaultProps = {};

DeliveredOrder.propTypes = {};

export default DeliveredOrder;
